<template>
   <el-container   style="display: block;" >
     <div >
       <img @click="goHome()"  :src="require('@/assets/image/goback.png')" style="position: absolute;left: 0;top: 0;z-index: 1008;opacity: 0.8;" :style="{'height':screenHeight*0.03+'px'}" >
     </div>
     <div style="position: fixed;z-index: 1005;background-color: #000;z-index: 1005;right: 0;top: 0;"  :style="{'width':screenHeight*0.42+'px','height':screenHeight*0.24+'px'}" >
       <video width="100%" height="100%" ref="videoPlayer" @ended="restartVideo" controls controlslist="nodownload noplaybackrate" disablePictureInPicture="true" id="myVideo1" v-if="ishows">
         <source :src="index_url" type="video/mp4">

       </video>
     </div>
     <div :style="{'width':screenWidth+'px','height':screenHeight+'px'}" @click="toPage()" style="z-index: 0;position: absolute;top: 0;">

      <img id='imageg' :src="back" style="width: 100%;height: 100%;">


     </div>

     <div style="display: flex;flex-wrap: wrap;position: absolute;" @click="toPage()" :style="{'width':screenWidth+'px','height':screenHeight+'px'}">
      <div>
        <img :src="require('@/assets/image/shop.png')"   :height="screenHeight*0.42+'px'" @click="toPage()" style="position: absolute;top:5%;z-index: 5;width: 240px;height: 48px;left: 28%;">
      </div>

      <div>
        <img :src="list[15]['url']"    :height="screenHeight*0.26+'px'" @click="open()" style="position: absolute;top: 5%;z-index: 1;left: 45%;">
      </div>
      <div>
        <img :src="list[24]['url']"    :height="screenHeight*0.26+'px'" @click="open()" style="position: absolute;top: 5%;z-index: 1;left: 59%;">
      </div>



      <div>
        <img :src="list[0]['url']"   :height="screenHeight+'px'" @click="open()" style="position: absolute;bottom: 0;z-index: 1;left: -8%;">
      </div>
      <div>
        <img :src="list[23]['url']"   :height="screenHeight*0.8+'px'" @click="open()" style="position: absolute;bottom: 0;z-index: 0;left: 39%;">
      </div>
      <div>
        <img :src="list[13]['url']"   :height="screenHeight*0.8+'px'" @click="open()" style="position: absolute;bottom: 0;z-index: 0;left: 69%;">
      </div>




      <div>
        <img :src="list[1]['url']"   :height="screenHeight*0.4+'px'" @click="open()" style="position: absolute;bottom: 0;z-index: 5;left: -1%;">
      </div>
      <div>
        <img :src="list[2]['url']"    :height="screenHeight*0.27+'px'" @click="open()" style="position: absolute;bottom: 0;z-index: 5;left: 9%;">
      </div>
      <div>
        <img :src="list[3]['url']"   :height="screenHeight*0.40+'px'" @click="open()" style="position: absolute;bottom: 0;z-index: 5;left: 17%;">
      </div>
      <div>
        <img :src="list[5]['url']"   :height="screenHeight*0.31+'px'" @click="open()" style="position: absolute;bottom: 0;z-index: 5;left: 27%;">
      </div>
      <div>
        <img :src="list[9]['url']"   :height="screenHeight*0.28+'px'" @click="open()" style="position: absolute;bottom: 0;z-index: 5;left: 46%;">
      </div>

      <div>
        <img :src="list[17]['url']"   :height="screenHeight*0.20+'px'" @click="open()" style="position: absolute;bottom: 0;z-index: 5;left: 60%;">
      </div>
      <div>
        <img :src="list[25]['url']"   :height="screenHeight*0.24+'px'" @click="open()" style="position: absolute;bottom: 0;z-index: 5;left: 72%;">
      </div>
      <div>
        <img :src="list[20]['url']"   :height="screenHeight*0.24+'px'" @click="open()" style="position: absolute;bottom: 0;z-index: 5;left: 79%;">
      </div>





      <div>
        <img :src="list[21]['url']"   :height="screenHeight*0.6+'px'" @click="open()" style="position: absolute;bottom: 0;z-index: 1;left: 2%;">
      </div>
      <div>
        <img :src="list[16]['url']"   :height="screenHeight*0.6+'px'" @click="open()" style="position: absolute;bottom: 0;z-index: 1;left: 10%;">
      </div>
      <div>
        <img :src="list[22]['url']"   :height="screenHeight*0.6+'px'" @click="open()" style="position: absolute;bottom: 0;z-index: 1;left: 15%;">
      </div>
      <div>
        <img :src="list[4]['url']"   :height="screenHeight*0.6+'px'" @click="open()" style="position: absolute;bottom: 0;z-index: 1;left: 23%;">
      </div>
      <div>
        <img :src="list[6]['url']"   :height="screenHeight*0.6+'px'" @click="open()" style="position: absolute;bottom: 0;z-index: 1;left: 32%;">
      </div>
      <div>
        <img :src="list[7]['url']"   :height="screenHeight*0.6+'px'" @click="open()" style="position: absolute;bottom: 0;z-index: 1;left: 38%;">
      </div>
      <div>
        <img :src="list[8]['url']"   :height="screenHeight*0.6+'px'" @click="open()" style="position: absolute;bottom: 0;z-index: 1;left: 46%;">
      </div>
      <div>
        <img :src="list[10]['url']"   :height="screenHeight*0.6+'px'" @click="open()" style="position: absolute;bottom: 0;z-index: 1;left: 54%;">
      </div>
      <div>
        <img :src="list[18]['url']"   :height="screenHeight*0.6+'px'" @click="open()" style="position: absolute;bottom: 0;z-index: 1;left: 60%;">
      </div>
      <div>
        <img :src="list[11]['url']"   :height="screenHeight*0.6+'px'" @click="open()" style="position: absolute;bottom: 0;z-index: 1;left: 69%;">
      </div>
      <div>
        <img :src="list[12]['url']"   :height="screenHeight*0.6+'px'" @click="open()" style="position: absolute;bottom: 0;z-index: 1;left: 76%;">
      </div>
      <div>
        <img :src="list[14]['url']"   :height="screenHeight*0.6+'px'" @click="open()" style="position: absolute;bottom: 0;z-index: 1;left: 83%;">
      </div>

      <div>
        <img :src="list[19]['url']"   :height="screenHeight*0.6+'px'" @click="open()" style="position: absolute;bottom: 0;z-index: 5;left: 92%;">
      </div>

     </div>


    <div class="beian1">
     <a href="http://beian.miit.gov.cn/state/outPortal/loginPortal.action" rel="noreferrer" target="_blank" style="text-decoration:none;color: #fff;background-color: black;">粤ICP备2024237244号@2024 © 宇宙之幂</a>


    </div>

   </el-container>







</template>


<script>

  export default {
    data() {
      return {
        list:[],
        back:'https://images.yoooooo.com/image/others/changjing/img/changjing/2/1.gif',
        backs:['https://images.yoooooo.com/image/others/changjing/img/changjing/4/1.gif','https://images.yoooooo.com/image/others/changjing/img/changjing/2/1.gif','https://images.yoooooo.com/image/others/changjing/img/changjing/3/1.gif'],
        screenWidth : window.innerWidth,
        screenHeight : window.innerHeight,
        vwidth:(window.innerWidth-20)/20,
        vheight : window.innerHeight/200,
        index_url:'https://video.universepower.cn/yuzhouzhimi/universepower_hunshayuzhou_zhiyeren_jinshasha_video3.mp4',
        ishows:false
      };
    },
    mounted() {


      },
      beforeDestroy() {

      },
    created() {

      this.loadList()
      this.getScreen()



    },

	methods:{
    goHome() {

      this.$router.push('/');
    },
    restartVideo() {
      this.$refs.videoPlayer.currentTime = 0;
      this.$refs.videoPlayer.play();
    },
    opens(url){


      this.ishows = false
      this.index_url = ""
      setTimeout(() => {
        this.ishows = true
        this.index_url = url

        this.$nextTick(() => {
          if (this.$refs.videoPlayer) {
            this.$refs.videoPlayer.play();
          }
        });
      }, 200);

    },
    getScreen() {
      if(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i )){
        window.location.href='http://m.universe.top/shop'

      }

    },
    startVideo() {
      var that = this
      var bac = 0
      var bkey = 0
      this.interval2 = setInterval(() => {
        if(bac > 7){
          // if(bkey == 2){
          //   bkey = 0
          // }else{
          //   bkey = bkey + 1
          // }
          bkey = Math.floor(Math.random() * 3)
          that.back = that.backs[bkey]
          bac = 0
        }else{

          bac = bac + 1
        }
        that.list.forEach(function(item, index) {

          if(item['num']<item['nums']){
            item['num'] = item['num']+1;
            that.$set(that.list,index,item);
            // that.$set(that.list, index, {'id':item['id'],'img':item['img'],'name':item['name'],'url':item['url'],'num':item['num']+1,'nums':item['nums'],'typea':item['typea'],'typeb':item['typeb'],'typec':item['typec'],'typed':item['typed']});
          }else{
            var tt = Math.floor(Math.random() * item['imgs'].length)
            item['url'] = item['imgs'][tt]
            item['num'] = 0;

            that.$set(that.list,index,item);
          }

        })

      }, 1000);

    },

    toPage(name){
      this.$router.push('/shop1');
    },
    loadList(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          name:'宇宙一次幂(深圳)机器人有限公司',


      	},
      	url:'https://tossp.yoooooo.com/index.php/index/data/shopList'
      })
      .then(res=>{
        this.list = res.data.list;
        this.index_url = res.data.index_url;
        this.opens(this.index_url)
        var bkey = Math.floor(Math.random() * 3)
        this.back = this.backs[bkey]
        // this.list.forEach(function(item, index) {
        //    item['typed'] = 0;
        //    item['typec'] = 2;
        //    item['typeb'] = 2;
        //    item['typea'] = 0;

        // })
        this.startVideo()

      })
      .catch(err=>{

      });
    },
		msg(msg,type){
			this.$message({
			  message: msg,
			  type: type
			});
		},



	}


  }
</script>

<style>
  @keyframes float5 {
    0% { transform: translate(20px, 20px); }
    50% { transform: translate(600px, 20px); }

    100% { transform: translate(20px, 20px); }
  }

  .float-animation5 {
    /* display: inline-block; */
    animation: float5 40s infinite;
  }
.donghuap{
  display: flex;
  justify-content: center;
  /* flex-direction: column; */
  overflow-x: hidden;
  position: relative;
  text-align: center;
}
.donghuai{
  display: flex;
  transform: translateX(200%);
  transition: transform 0.4s ease;
  justify-content: center;
}
.adonghua{
  visibility: hidden;
}
.ddonghua{
  transform: translateX(0);
}
.edonghua{
  display: flex;
  transform: translateX(-200%);
  transition: transform 0.6s ease;
  justify-content: center;
}
.el-dropdown-menu__item{
  color: #ffffff;
  font-weight: bold;
  font-family: guanwangdaohang;
}
.popper__arrow{
  display: none;
}

  .content{
  	background: #939AA0;
  	width: 100%;
  	height: 100%;
  }
  body {
  overflow-x:hidden;
  overflow-y:hidden;
  }
  .el-scrollbar__wrap{
    background-color: black;
  }
  .bordered-box{
     overflow-wrap: break-word;
     /* margin-left: 20px; */
  }

 .beian1 {
    position: fixed; /* 定位为固定位置，覆盖整个视窗 */
    color: #616161;
    /* top: 0; */
    left: 42%;
    /* right: 0; */
    bottom: 0;

    z-index: 1000; /* 确保蒙层在其他内容之上 */
  }




</style>



// WEBPACK FOOTER //
// src/components/main/shop.vue